import {Tab, Tabs, TabPanel, TabPanels} from './tab'
import {LoadMore, ListView} from './list-view'
import Footer from './footer'
import {DefaultLayout} from './layout'
import {Swiper, SwiperItem} from './swiper'
import InfiniteScroll from './infinite-scroll'
import CountUp from './count'
import {RadioSelector} from './radio-selector'
import {Filters, FiltersItem, SortCaret} from './filters'
import {SearchDrawer, SearchDrawerItem} from './search-drawer'
import {Drawer, Popup} from './popup'
import {Cell, Field, SmsField, List} from './cell'
import PageDrawer from './page-drawer'
import {Button} from './button'
import Navbar from './navbar'
import Avatar from './avatar'
import {Steps, Step} from './step'
import Warns from './warns'
import Sku from './sku'
import CollapseTransition from './collapse-transition'

const components = {
  Tab,
  Tabs,
  TabPanel,
  TabPanels,
  LoadMore,
  ListView,
  Footer,
  DefaultLayout,
  Swiper,
  SwiperItem,
  InfiniteScroll,
  CountUp,
  RadioSelector,
  Filters,
  FiltersItem,
  SortCaret,
  SearchDrawer,
  SearchDrawerItem,
  PageDrawer,
  Drawer,
  Popup,
  Cell,
  List,
  Field,
  SmsField,
  Button,
  Navbar,
  Avatar,
  Steps,
  Step,
  Warns,
  Sku,
  CollapseTransition
}

const install = Vue => {
  for (let key in components) {
    if (components.hasOwnProperty(key)) {
      let component = components[key]
      if (component.install) component.install(Vue)
      else {
        Vue.component(component.name ? component.name : key, component)
      }
    }
  }
}

export default {
  install,
  ...components
}



// WEBPACK FOOTER //
// ./src/components/index.js